import React, { useEffect, useState } from 'react';
import styles from './TimeLine.module.scss';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faIndustry, faUsers, faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';

import { computeContestPhase, hasCommunityVote } from '../../helpers/contestUtilities';

import TimerWLF from './components/TimerWLF';
import ProgressSection from './components/ProgressSection';
import { Contest } from '../../global';
import DesallStore from '../../store/DesallStore';
import { getTimeLeft } from '../../store/DesallSelectors';
import { useStoreState } from 'pullstate';

interface TimelineWLFProps {
  contest: Contest;
}

const TimeLineWLF: React.FC<TimelineWLFProps> = ({ contest }) => {
  const [communityVoteEnabled, setCommunityVoteEnabled] = useState(false);
  const [totalUpload, setTotalUpload] = useState(0);
  const [passedUpload, setPassedUpload] = useState(0);
  const [totalCommunity, setTotalCommunity] = useState(0);
  const [passedCommunity, setPassedCommunity] = useState(0);
  const [totalClient, setTotalClient] = useState(0);
  const [passedClient, setPassedClient] = useState(0);

  const [uploadActive, setUploadActive] = useState(false);
  const [communityActive, setCommunityActive] = useState(false);
  const [clientActive, setClientActive] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const timeLeft = useStoreState(DesallStore, getTimeLeft);

  useEffect(() => {
    if (contest) {
      setCommunityVoteEnabled(hasCommunityVote(contest));
      setUploadActive(false);
      setTotalUpload(100);
      setPassedUpload(100);
      setCommunityActive(false);
      setTotalCommunity(100);
      setPassedCommunity(100);
      setClientActive(false);
      setTotalClient(100);
      setPassedClient(100);
      const phase = computeContestPhase(contest);
      if (phase === 'closed') {
        setIsClosed(true);
        return;
      }
      setIsClosed(false);
      if (phase === 'upload-phase') {
        setUploadActive(true);
        setTotalUpload(Math.trunc((new Date(contest.endUploadDate).getTime() - new Date(contest.startDate).getTime()) / 86400000));
        setPassedUpload(Math.trunc((new Date().getTime() - new Date(contest.startDate).getTime()) / 86400000));
        return;
      }
      if (phase === 'community-vote') {
        setCommunityActive(true);
        setTotalCommunity(Math.trunc((new Date(contest.endVotingDate).getTime() - new Date(contest.endUploadDate).getTime()) / 86400000));
        setPassedCommunity(Math.trunc((new Date().getTime() - new Date(contest.endUploadDate).getTime()) / 86400000));
        return;
      }
      if (phase === 'client-vote') {
        setClientActive(true);
        setTotalClient(100);
        setPassedClient(50);
        return;
      }
    }
  }, [contest]);

  // useEffect(() => {
  //   const setContestEndDate = () => {
  //     console.log('setContestEndDate');
  //     console.log(contest);
  //     const date = new Date().getTime();

  //     if (date > new Date(contest.startDate).getTime() && date < new Date(contest.endUploadDate).getTime()) {
  //       console.log('upload contest normale');
  //       setUploadActive(true);
  //       setClientActive(false);
  //       setCommunityActive(false);
  //       setTotalUpload(Math.trunc((new Date(contest.endUploadDate).getTime() - new Date(contest.startDate).getTime()) / 86400000));
  //       console.log('setto passed');
  //       console.log((date - new Date(contest.startDate).getTime()) / 86400000);
  //       setPassedUpload(Math.trunc((date - new Date(contest.startDate).getTime()) / 86400000));
  //     } else if (contest.endVotingDate && new Date(contest.endVotingDate).getTime() > new Date(contest.endUploadDate).getTime()) {
  //       console.log('community vote contestsss');
  //       setCommunityActive(!contest.isPrivate);
  //       if (date > new Date(contest.endUploadDate).getTime() && date < new Date(contest.endVotingDate).getTime()) {
  //         console.log('community vote contest normale');
  //         setClientActive(false);
  //         setUploadActive(false);
  //         setTotalUpload(100);
  //         setPassedUpload(100);
  //         setTotalCommunity(Math.trunc((new Date(contest.endVotingDate).getTime() - new Date(contest.endUploadDate).getTime()) / 86400000));
  //         setPassedCommunity(Math.trunc((date - new Date(contest.endUploadDate).getTime()) / 86400000));
  //       } else if (date > new Date(contest.endVotingDate).getTime()) {
  //         console.log('client vote contest normale');
  //         console.log(contest.endVotingDate);
  //         console.log(contest.hypotheticalEndDate);
  //         if (contest.hypotheticalEndDate) {
  //           setUploadActive(false);
  //           setTotalUpload(100);
  //           setPassedUpload(100);

  //           setTotalCommunity(100);
  //           setPassedCommunity(100);

  //           setClientActive(true);
  //           setTotalClient(Math.trunc((new Date(contest.hypotheticalEndDate).getTime() - new Date(contest.endVotingDate).getTime()) / 86400000));
  //           setPassedClient(Math.trunc((date - new Date(contest.endVotingDate).getTime()) / 86400000));
  //         } else if (contest.isClosed) {
  //           setUploadActive(false);
  //           setTotalUpload(100);
  //           setPassedUpload(100);
  //           setTotalCommunity(100);
  //           setPassedCommunity(100);
  //           setClientActive(false);
  //           setTotalClient(100);
  //           setPassedClient(100);
  //         }
  //       }
  //     } else {
  //       console.log('BAH');
  //       if (contest.isClosed) {
  //         setUploadActive(false);
  //         setTotalUpload(100);
  //         setPassedUpload(100);
  //         setTotalCommunity(100);
  //         setPassedCommunity(100);
  //         setClientActive(false);
  //         setTotalClient(100);
  //         setPassedClient(100);
  //       } else {
  //         setClientActive(true);
  //         setUploadActive(false);
  //         setTotalUpload(100);
  //         setPassedUpload(100);
  //         setTotalClient(100);
  //         setPassedClient(50);
  //       }
  //     }
  //     // }
  //   };
  //   if (contest) {
  //     setContestEndDate();
  //   }
  // }, [contest]);

  const uploadProgress: number = (passedUpload / totalUpload) * 100;
  const communityProgress: number | undefined = totalCommunity && passedCommunity ? (passedCommunity / totalCommunity) * 100 : undefined;
  const clientProgress: number = (passedClient / totalClient) * 100;

  // let isClosed: boolean = uploadProgress + (communityProgress ?? 100) + clientProgress === 300;

  return (
    <div className={`row ${styles.timelineContainer}`}>
      <div className="col-12">
        <div className={`row ${styles.timelineWrapper} ${isClosed && styles.closed} px-0 d-flex`}>
          <TimerWLF />

          <div className={`col-3 g-0 flex-grow-1 ${styles.progressWrapper} ${styles.upload}  ${!uploadActive && styles.closed}`}>
            <ProgressSection
              progress={uploadProgress}
              label="Upload Phase"
              icon={faCloudArrowUp as IconProp}
              iconLabel="upload phase"
              daysLeft={timeLeft.days}
              // active={TLHLP.isUploadActive(props.progress)}
              active={uploadActive}
            />
          </div>

          {communityVoteEnabled && (
            <div className={`col-2 g-0 ${styles.progressWrapper} ${styles.community} ${!communityActive && styles.closed}`}>
              <ProgressSection
                progress={uploadProgress > 99 ? (passedCommunity * 100) / totalCommunity : 0}
                label="Vote"
                icon={faUsers as IconProp}
                iconLabel="community vote"
                daysLeft={timeLeft.days}
                active={communityActive}
              />
            </div>
          )}
          <div className={`col-2 g-0 ${styles.progressWrapper} ${styles.client} ${!clientActive && styles.closed}`}>
            <ProgressSection
              progress={clientProgress}
              label="Client Vote"
              icon={faIndustry as IconProp}
              iconLabel="client vote"
              daysLeft={0}
              active={clientActive}
              pero={isClosed ? 1 : 0}
            />
          </div>
          <div className={`col flex-shrink-1 ${styles.progressWrapper} ${styles.endSection} m-0 p-0`}>
            {isClosed && <ProgressSection progress={100} label="Closed" closed={true} daysLeft={0} active={true} pero={1} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeLineWLF;
